// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__15i9_","signatureBlock":"Footer_signatureBlock__31jU8","signature":"Footer_signature__2KW5x"};